module.exports = __webpack_public_path__ + "media/images/patterns/1-69e63b94f777d064efd7441c453fdd31.png";